import * as Blockly from 'blockly/core';

const SEPARATOR_MAP: Record<string, string> = {
    NONE: '',
    COMMA: ', ',
    SPACE: ' ',
    TAB: '\t',
};

export function register(gen: any): void {
    gen.forBlock['monitor_print'] = function (block: Blockly.Block): string {
        const liveIds = block.inputList.filter((i) => i.name.startsWith('VAL_')).map((i) => i.name.replace('VAL_', ''));
        const sep = SEPARATOR_MAP[block.getFieldValue('SEPARATOR')] ?? '';
        const newline = (block as any)._newlineValue ?? block.getFieldValue('NEWLINE') ?? 'ALL';
        const values = liveIds.map((id) => gen.valueToCode(block, `VAL_${id}`, 0) || '0');
        const lines: string[] = [];
        values.forEach((v, i) => {
            const isLast = i === values.length - 1;
            const useNewline = newline === 'ALL' || (newline === 'LAST' && isLast);
            const fn = useNewline ? 'println' : 'print';
            lines.push(`Serial.${fn}(${v});`);
            if (!isLast && sep !== '') {
                const sepNewline = newline === 'ALL';
                lines.push(`Serial.${sepNewline ? 'println' : 'print'}("${sep}");`);
            }
        });

        return lines.join('\n') + '\n';
    };
}
